import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Confetti.css';

const Confetti = ({ active = false, duration = 3000, onComplete }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (active) {
      // Generate confetti particles
      const newParticles = Array.from({ length: 50 }).map((_, i) => ({
        id: i,
        x: Math.random() * 100,
        delay: Math.random() * 0.5,
        duration: 2 + Math.random() * 1,
        rotation: Math.random() * 360,
        color: ['#e50914', '#ff4458', '#10b981', '#3b82f6', '#f59e0b', '#8b5cf6'][
          Math.floor(Math.random() * 6)
        ],
        size: 8 + Math.random() * 6
      }));
      
      setParticles(newParticles);

      // Auto cleanup
      const timeout = setTimeout(() => {
        setParticles([]);
        onComplete?.();
      }, duration);

      return () => clearTimeout(timeout);
    }
  }, [active, duration, onComplete]);

  return (
    <AnimatePresence>
      {active && (
        <div className="confetti-container">
          {particles.map((particle) => (
            <motion.div
              key={particle.id}
              className="confetti-particle"
              initial={{
                x: `${particle.x}vw`,
                y: '-10vh',
                rotate: 0,
                opacity: 1
              }}
              animate={{
                y: '110vh',
                rotate: particle.rotation * 4,
                opacity: [1, 1, 0.5, 0]
              }}
              transition={{
                duration: particle.duration,
                delay: particle.delay,
                ease: 'easeIn'
              }}
              style={{
                backgroundColor: particle.color,
                width: `${particle.size}px`,
                height: `${particle.size}px`
              }}
            />
          ))}
        </div>
      )}
    </AnimatePresence>
  );
};

export default Confetti;
